import { Box } from '@pets-ui/Box/Box'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { useTranslation } from 'react-i18next'

export function NoTrackingNumber() {
  const { t } = useTranslation()
  return (
    <Box p="6px" backgroundColor={colors.blueGrey50} borderRadius="4px">
      <Text color={colors.grey500}>{t('orderDetail.noTrackingNumber', { defaultValue: '尚無託運單號' })}</Text>
    </Box>
  )
}
